import { Alert, Button, Dialog, DialogActions, DialogContent } from "@mui/material"
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next"

const SessionExpireUi = ({ReLogin, setReLogin}) => {
    const { t } = useTranslation();
    const CloseDialog = () => {
            setReLogin(false);
            localStorage.clear();
            sessionStorage.clear();
            window.location.href = "/";
            Cookies.remove("token");
            Cookies.remove("admin_id");
            Cookies.remove("organization");
            Cookies.remove("instructor_id");
            Cookies.remove("plan");
            Cookies.remove("activatedTrial");
        }
    return (
        <div>
            <Dialog open={ReLogin} onClose={CloseDialog}>
                <DialogContent>
                    <Alert severity="error">{t("Signin.SessionExp")}</Alert>

                </DialogContent>
                <div className="flex justify-center">
                    <DialogActions>
                        <Button onClick={CloseDialog}>{t("Signin.Relogin")}</Button>

                    </DialogActions>
                </div>
            </Dialog>
        </div>
    )
};
export default SessionExpireUi;